import type { IconComponent } from '@consta/icons/Icon'
import { IconAlignJustify } from '@consta/icons/IconAlignJustify'
import { IconCards } from '@consta/icons/IconCards'
import type { ProjectId } from 'common/types'

import type { ProjectDetail } from '../../../types'

export enum SwitchViewGroup {
  CARDS = 'Карточный',
  TABLE = 'Табличный',
}

export type ItemSwitchViewGroupType = {
  name: SwitchViewGroup
  icon: IconComponent
}

export type ProjectDetailExtended = ProjectDetail & { isFavorite: boolean }
export type ProjectsViewProps = {
  projects: ProjectDetailExtended[]
  toggleFavorite: (projectId: ProjectId) => void
}

/** пока на бэке это не готово, месторождения и статус мокаю */
export interface IProjectDetailListMockProp extends ProjectDetail {
  id: string
  organizationName?: string
  fieldName?: string
  status?: string
  companyName?: string
  tags?: string[]
}

export const itemsSwitchViewGroup: ItemSwitchViewGroupType[] = [
  { name: SwitchViewGroup.CARDS, icon: IconCards },
  { name: SwitchViewGroup.TABLE, icon: IconAlignJustify },
]
